import { type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Icon } from "./icon";

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  description,
  align = "center",
  icon,
  accent,
  className,
}: {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  description?: ReactNode;
  align?: "center" | "left";
  icon?: string;
  accent?: "crimson" | "purple" | "cyan" | "emerald" | "amber" | "denim" | "violet" | "rose";
  className?: string;
}) {
  const accentColor = accent ? `var(--color-${accent})` : "var(--color-crimson)";
  const body = description ?? subtitle;
  return (
    <div
      className={cn(
        "flex flex-col gap-5 max-w-3xl mb-12",
        align === "center" ? "items-center text-center mx-auto" : "items-start text-left",
        className,
      )}
    >
      {eyebrow && (
        <div className="inline-flex items-center gap-2.5 px-4 py-1.5 rounded-full glass eyebrow-section">
          {icon && <Icon name={icon} className="h-3.5 w-3.5" style={{ color: accentColor }} />}
          <span className="text-[rgb(var(--fg-muted))]">{eyebrow}</span>
        </div>
      )}
      <h2 className="text-balance">{title}</h2>
      {body && (
        <p className="text-body-sm leading-relaxed text-[rgb(var(--fg-muted))] max-w-2xl">
          {body}
        </p>
      )}
    </div>
  );
}

